import React, { PropsWithChildren, type FC } from "react";
import classes from "./BackgroundLayout.module.css";

type BackgroundLayoutPropType = PropsWithChildren<{
  paddingBottom?: boolean;
  style?: React.CSSProperties;
}>;

const BackgroundLayout: FC<BackgroundLayoutPropType> = ({
  children,
  paddingBottom,
  style,
}) => {
  return (
    <div
      className={`${classes.background_wrapper} ${
        paddingBottom && classes.paddingBottom
      }`}
    >
      <div className={`${classes.wrapper}`}>
        {children}
      </div>
    </div>
  );
};

export default BackgroundLayout;